import React from "react"
import "./frames.css"

const SistemaEstandarBIBS = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Sistema Estándar A y Sistema de Respiración Incorporado (BIBS B)
      </h1>

      <h2 className="frames-subtitle">
        Sistema Estándar A: Presurización con O2
      </h2>
      <p className="frames-text">
        El Sistema Estándar A de las cámaras Perry Baromedical ofrece una
        presurización eficaz con oxígeno puro. Este método garantiza que los
        pacientes respiren un ambiente oxigenado durante la terapia hiperbárica,
        asegurando un tratamiento óptimo.
      </p>

      <h2 className="frames-subtitle">
        Breathing System BIBS B: Versatilidad en Respiración
      </h2>

      <h2 className="frames-subsection">¿Qué es el Sistema BIBS?</h2>
      <p className="frames-text">
        BIBS es la sigla de Built-In Breathing System, que significa Sistema de
        Respiración Incorporado. Este avanzado sistema está especialmente
        diseñado para las cámaras hiperbáricas de Perry Baromedical.
      </p>

      <h2 className="frames-subsection">Funcionalidades Destacadas</h2>
      <ul className="frames-text">
        <li>
          Selección de Gas para Presurización: El sistema BIBS permite
          seleccionar el tipo de gas con el que se presurizará la cámara,
          ofreciendo dos opciones:
          <ul>
            <li>
              Presurización con aire: El paciente respira oxígeno puro a través
              de una mascarilla.
            </li>
            <li>
              Presurización con O2: No es necesario utilizar una mascarilla,
              excepto para incluir el "Air Break" (pausa para respirar aire).
            </li>
          </ul>
        </li>
        <li>
          Compatibilidad de Modelos: Este sistema está disponible para los
          modelos SIGMA 34, 36 y 40.
        </li>
        <li>
          Economía y Eficiencia: Este es el sistema ideal para lugares con un
          suministro de oxígeno irregular, de difícil implementación o de alto
          costo.
        </li>
        <li>
          Estudios Doble Ciego: El sistema está diseñado para facilitar estudios
          de doble ciego. La selección del gas suministrado (aire o oxígeno) se
          puede hacer a través de la mascarilla o el "hood" que utiliza el
          paciente para respirar.
        </li>
        <li>
          Conmutador de O2/Aire: Este sistema incluye un conmutador que permite
          cambiar fácilmente entre oxígeno y aire, ofreciendo una flexibilidad
          adicional durante el tratamiento.
        </li>
      </ul>

      <p className="frames-text">
        Con la implementación del Sistema BIBS, Perry Baromedical sigue
        liderando en innovación y calidad en el campo de la medicina
        hiperbárica, asegurando que los pacientes reciban la atención más segura
        y eficaz posible.
      </p>
    </div>
  )
}

export default SistemaEstandarBIBS
